<template>
  <div class="doubleFestival-page">
    <div v-wechat-title="'《最强蜗牛》双旦奇妙夜'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
      :autoOpenOS="autoOpenOS" v-on:loginSuccess="loginSuccess" @selectCallback="loginCallback" :noAuthLogin="true"
      :channelDist="39" channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @downloadMonitor="downloadApp" />
    <!-- 内容 -->

    <div class="active-page">
      <div class="section-container">
        <div class="section section1">
          <div class="banner"></div>
          <div class="banner-download-btn" data-snail-report-name="banner-下载游戏" @click="downloadApp"></div>

          <div class="team-consumption-box" id="team-consumption-box">
            <div class="detail-btn" data-snail-report-name="活动规则按钮" @click="showPopup('teamDetailShow')"></div>
            <div class="time" v-if="isActiveAppointment">
              <img class="time_1" src="../../../../assets/images/active/snail/doubleFestival/pre-team_formation_tips.png"
                alt="">
            </div>
            <div v-else class="date">
              <img class="date_1" src="../../../../assets/images/active/snail/doubleFestival/team_formation_tips.png"
                alt="">
            </div>
            <div class="team-consumption-content">
              <div class="member-num">
                队伍人数:【{{ memberNum }}/6】
                <div v-if="isActiveAppointment && userInfo.user_id && memberNum && !teamOutStatus" class="exit-btn"
                  data-snail-report-name="退出队伍按钮" @click="showPopup('teamExitShow')"></div>
              </div>
              <div class="member-list">
                <ul>
                  <li v-for="(item, idx) in teamList" :key="idx">
                    <div v-if="item.id" class="player-info">
                      <img class="avatar" :src="item.pic" alt="" @click="readPlayerInfo(item.id)">
                      <div class="name">{{ item.is_myself ? '我' : item.nick_name }}</div>
                      <div v-if="item.is_first" class="captain"></div>
                      <div v-if="item.is_kick_out" class="member" data-snail-report-name="队长踢出队伍按钮"
                        @click.stop="kickoutPlayer(item.id)"></div>
                    </div>
                    <div v-else>
                      <div class="player-info empty-seat" data-snail-report-name="邀请好友" @click="onTeamShare()">
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="tips">
                <img src="../../../../assets/images/active/snail/doubleFestival/recharge_date_tips.png" alt="">
              </div>
              <div v-if="memberNum === 6" class="full-capacity-btn"></div>
              <div v-else class="invitation-btn" data-snail-report-name="邀请好友" @click="onTeamShare()"></div>
            </div>
            <div :class="'egg-btn pause-' + eggPause" data-snail-report-name="彩蛋按钮" @click="showEgg()"></div>
          </div>

          <div class="find_team_btn" data-snail-report-name="寻宝搭子按钮" @click="openFindTeamShow()">
            <img src="../../../../assets/images/active/snail/doubleFestival/find_team_icon.png" />
          </div>

          <div class="beter-energy-cube-box">
            <div class="people"></div>
          </div>

          <div class="consumption-points-box">
            <div class="hat"></div>
            <div class="operation-box">
              <div class="role-info" v-if="!userInfo.user_id">
                <!-- <p>尚未登录</p> -->
                <div class="no-login"></div>
              </div>
              <div v-else class="role-info">
                <p class="name">{{ (hideAccount(userInfo.account)) }}</p>
              </div>
              <div class="team-points">
                小队累计算力:&nbsp;<span>{{ teamScore || 0 }}</span> <b data-snail-report-name="查看积分列表"
                  @click="onMorePoints()"></b>
              </div>
              <div class="login-mask" v-if="!userInfo.user_id" data-snail-report-name="积分领取登录"
                @click="openLoginByScore()"></div>
            </div>
            <div class="go_immediately_btn" data-snail-report-name="前往官充" @click="toRecharge()"></div>

            <div class="welfare-list">
              <div class="reward-box" v-for="(item, idx) in packageList" :key="idx">
                <div :class="'reward-item reward-item-' + (idx + 1)">
                  <div class="lock-box">
                    <div :class="'lock lock-' + (idx + 1) + ' lock_' + item.status"
                      :data-snail-report-name="'查看锁定奖励礼包' + (idx + 1)" @click="clickReward(idx)"></div>
                    <div :class="'lock_status ' + item.status">
                    </div>
                    <div class="text">
                      <p class="lock_criterion">
                        {{ teamScore || 0 }}/{{ item.score }}算力
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="activities-box">
            <div class="snowman"></div>
            <div class="activities-content">
              <div class="tabs-container" ref="tabsContainer">
                <div v-for="(tab, index) in activitiesCards" ref="tabItems" :key="index"
                  :class="['tab-item', `tab-item-${index + 1}`, { active: activeIndex === index }]"
                  @click="goToSlide(index)">
                </div>
              </div>
              <div class="activities-swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="card in activitiesCards" :key="card.id">
                    <div class="top-content">
                      <img :src="card.image" alt="">
                    </div>
                    <div class="bottom-content">
                      <img :src="card.image2" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-go" @click="enterUrl"
                :class="{ disabled: isNotStarted(activitiesCards.find((i, index) => index === activeIndex).time) }" />
              <div class="activities-swiper-button-next swiper-button-next"></div>
              <div class="activities-swiper-button-prev swiper-button-prev"></div>
              <div class="activities-swiper-pagination swiper-pagination"></div>
            </div>
          </div>

          <div class="game-feature-box">
            <div class="milu"></div>
            <div class="game-feature-content">
              <div class="game-feature-swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="card in gameFeatureCards" :key="card.id">
                    <img :src="card.image" alt="">
                  </div>
                </div>
              </div>
              <div class="game-feature-swiper-button-next swiper-button-next"></div>
              <div class="game-feature-swiper-button-prev swiper-button-prev"></div>
              <div class="game-feature-swiper-pagination swiper-pagination"></div>
            </div>
          </div>

          <!-- 组队消费分享 -->
          <div class="team-share-box" ref="teamImageDom">
            <img src="../../../../assets/images/active/snail/doubleFestival/popup/team-share-popup.png" />

            <div class="share-img">
              <div class="qrcode-box">
                <div id="team-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 彩蛋弹窗 -->
    <div class="egg-pop-wrap popup_wrap" v-show="eggPopShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="egg-btn-box popup_wrap-box" v-show="eggPopShow">
          <div class="monitor-btn" @click="onCopy('egg-clipboard-btn')" id="egg-clipboard-btn"
            data-snail-report-name="复制密令" data-event="复制密令" data-clipboard-text="圣诞老人鹂尔多隆吗"></div>
          <div class="confirm-btn" @click="closePopup('eggPopShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-show="eggPopShow" @click="closePopup('eggPopShow')"></div>
    </div>

    <!-- 组队消费弹窗组 -->
    <div>
      <!-- 组队消费——详情弹窗 -->
      <div class="team-detail-wrap popup_wrap" v-show="teamDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-detail-box popup_wrap-box" v-show="teamDetailShow">
            <div class="detail-content" v-if="teamDetailShow">
              <img src="../../../../assets/images/active/snail/doubleFestival/popup/team-rule.png" alt="">
            </div>
            <div class="close-btn" v-show="teamDetailShow" @click="closePopup('teamDetailShow')"></div>

          </div>
        </transition>
        <div class="close-bg" v-show="teamDetailShow" @click="closePopup('teamDetailShow')"></div>
      </div>

      <!-- 组队消费——踢出队伍弹窗 -->
      <div class="team-kickout-wrap popup_wrap" v-show="teamKickoutShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-kickout-box popup_wrap-box" v-show="teamKickoutShow">
            <div class="player-info">
              <div class="top">
                <div class="avatar-box">
                  <img class="avatar" :src="curPlayerInfo.pic" alt="">
                </div>
                <div class="name">{{ curPlayerInfo.nick_name || '' }}</div>
              </div>
            </div>

            <div :class="'btn-box align-' + curPlayerInfo.is_kick_out">
              <div class="btn" v-if="curPlayerInfo.is_kick_out">
                <div v-if="showGrayKickOutBtn" class="gray-kick-out-btn">
                  <span>倒计时:{{ kickOutSeconds }}秒</span>
                </div>
                <div v-else class="kick-out-btn" data-snail-report-name="踢出队伍弹窗-踢出队伍按钮" @click="onKickOut()"></div>
              </div>
              <div class="btn confirm-btn" @click="closePopup('teamKickoutShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamKickoutShow" @click="closePopup('teamKickoutShow')"></div>
      </div>

      <!-- 组队消费——队友信息 -->
      <div class="team-player-info-wrap popup_wrap" v-show="teamPlayerInfoShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-player-info-box popup_wrap-box" v-show="teamPlayerInfoShow">
            <div class="player-info">
              <div class="top">
                <div class="avatar-box">
                  <img class="avatar" :src="curPlayerInfo.pic" alt="">
                </div>
                <div class="name">{{ curPlayerInfo.nick_name || '' }}</div>
              </div>

              <div class="info">
                <p class="row">
                  <span class="label">贡献算力：</span>
                  <span class="value">{{ isActiveAppointment ? 0 : (Number(curPlayerInfo.score) + 20) }}</span>
                </p>
              </div>
            </div>
            <div class="btn confirm-btn" @click="closePopup('teamPlayerInfoShow')"></div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamPlayerInfoShow" @click="closePopup('teamPlayerInfoShow')"></div>
      </div>

      <!-- 组队消费——玩家退出队伍弹窗 -->
      <div class="team-exit-wrap popup_wrap" v-show="teamExitShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-exit-box popup_wrap-box" v-show="teamExitShow">
            <div class="btn-box">
              <div class="btn cancel-btn" @click="closePopup('teamExitShow')"></div>
              <div class="btn confirm-btn" data-snail-report-name="退出队伍弹窗-确认退出" @click="onExitTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamExitShow" @click="closePopup('teamExitShow')"></div>
      </div>

      <!-- 组队消费——积分记录弹窗 -->
      <div class="team-points-record-wrap popup_wrap" v-show="teamPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-points-record-box popup_wrap-box" v-show="teamPointsRecordShow">
            <div class="record-box">
              <ul>
                <li v-for="(item, idx) of scoreList" :key="idx">
                  <div class="left">
                    <div class="name">{{ item.remark }}</div>
                    <div class="date">{{ item.created_at && formatDate(item.created_at) }}</div>
                  </div>
                  <div class="right">累计算力:<span>{{ item.score }}</span></div>
                </li>
              </ul>
            </div>

            <div class="tips">
              <p>当前累计算力为：<span>{{ teamScore || 0 }}</span></p>
            </div>
            <!-- <div class="close-btn" @click="closePopup('teamPointsRecordShow')"></div> -->
          </div>
        </transition>
        <div class="close-bg" v-show="teamPointsRecordShow" @click="closePopup('teamPointsRecordShow')"></div>
      </div>
      <!-- 组队消费——积分记录弹窗 无积分 -->
      <div class="team-not-points-record-wrap popup_wrap" v-show="teamNotPointsRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-not-points-record-box popup_wrap-box" v-show="teamNotPointsRecordShow">
            <div class="btn-box">
              <div class="btn confirm-btn" data-snail-report-name="获取积分" @click="toRecharge()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamNotPointsRecordShow" @click="closePopup('teamNotPointsRecordShow')"></div>
      </div>

      <!-- 组队消费——入队失败(满员) -->
      <div class="team-join-failed-full-strength-wrap popup_wrap" v-show="teamJoinFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-full-strength-box popup_wrap-box" v-show="teamJoinFailedFullStrengthShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedFullStrengthShow"
          @click="closePopup('teamJoinFailedFullStrengthShow')"></div>
      </div>
      <!-- 组队消费——入队失败(已有队伍) -->
      <div class="team-join-failed-has-team-wrap popup_wrap" v-show="teamJoinFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-has-team-box popup_wrap-box" v-show="teamJoinFailedHasTeamShow">
            <div class="btn-box">
              <div class="btn my-team-btn" @click="toMyTeamByTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedHasTeamShow" @click="closePopup('teamJoinFailedHasTeamShow')"></div>
      </div>
      <!-- 组队消费——入队失败(自己邀请自己) -->
      <div class="team-join-failed-myself-wrap popup_wrap" v-show="teamJoinFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-join-failed-myself-box popup_wrap-box" v-show="teamJoinFailedMyselfShow">
            <div class="btn-box">
              <div class="btn other-active-btn" @click="closePopup('teamJoinFailedMyselfShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamJoinFailedMyselfShow" @click="closePopup('teamJoinFailedMyselfShow')"></div>
      </div>
      <!-- 组队消费——邀请入队弹窗 -->
      <div class="team-invitation-join-wrap popup_wrap" v-show="teamInvitationJoinShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-invitation-join-box popup_wrap-box" v-show="teamInvitationJoinShow">
            <div v-if="isActiveAppointment" class="tip-01"></div>
            <div v-else class="tip-02"></div>
            <div class="btn-box">
              <div class="btn reject-btn" :data-snail-report-name="`接受邀请弹窗-${phaseLabel}-拒绝入队`"
                @click="closePopup('teamInvitationJoinShow')"></div>
              <div class="btn agree-btn" :data-snail-report-name="`接受邀请弹窗-${phaseLabel}-立即入队`" @click="openInvitetation()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationJoinShow" @click="closePopup('teamInvitationJoinShow')"></div>
      </div>
      <!-- 组队消费——邀请入队确认弹窗 -->
      <div class="team-invitation-confirm-wrap popup_wrap" v-show="teamInvitationConfirmShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="team-invitation-confirm-box popup_wrap-box" v-show="teamInvitationConfirmShow">
            <div v-if="isActiveAppointment" class="tip-01"></div>
            <div v-else class="tip-02"></div>
            <div class="btn-box">
              <div class="btn cancel-btn" :data-snail-report-name="`入队确认弹窗-${phaseLabel}-我再想想`"
                @click="closePopup('teamInvitationConfirmShow')"></div>
              <div class="btn confirm-btn" :data-snail-report-name="`入队确认弹窗-${phaseLabel}-确认入队`" @click="agreeJoinTeam()"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="teamInvitationConfirmShow" @click="closePopup('teamInvitationConfirmShow')"></div>
      </div>
    </div>

    <!-- 组队消费——微信分享 -->
    <div class="team-wechat-share-wrap popup_wrap" v-show="teamWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-wechat-share-box popup_wrap-box" v-show="teamWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="teamWechatShareShow" @click="closeWechatShare('teamWechatShareShow')"></div>
    </div>
    <!-- 组队消费——分享弹窗 -->
    <div class="team-share-wrap popup_wrap" v-show="teamNotWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="team-share-box popup_wrap-box" v-show="teamNotWechatShareShow">
          <img :src="teamShareImg" alt="分享图片" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('team-clipboard-btn')" id="team-clipboard-btn"
            data-snail-report-name="付费活动弹窗-复制链接" data-event="复制邀请链接"
            :data-clipboard-text="teamShareCopy.linkText"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="teamNotWechatShareShow" @click="closePopup('teamNotWechatShareShow')"></div>
    </div>

    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div class="btn qq-btn" data-snail-report-name="寻找搭子弹窗-去QQ" @click="toGroupOfQQ()"></div>
            <div class="btn wechat-btn" data-snail-report-name="寻找搭子弹窗-去微信" @click="toGroupOfWechat()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button class="monitor-btn" @click="onCopy('qq-clipboard-btn')" id="qq-clipboard-btn"
            data-snail-report-name="复制QQ群号" data-event="复制QQ群号" :data-clipboard-text="qqNumber"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="qqGroupShow" @click="closePopup('qqGroupShow')"></div>
    </div>

    <!-- 奖励弹窗组 -->
    <div>
      <!-- Beter的秘宝弹窗 -->
      <div class="beterSecret-wrap popup_wrap" v-show="beterSecretShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="beterSecret-box popup_wrap-box" v-show="beterSecretShow"></div>
        </transition>
        <div class="close-bg" v-show="beterSecretShow" @click="closePopup('beterSecretShow')"></div>
      </div>

      <!-- 奖励弹窗——开发者日记 -->
      <div class="diary-wrap popup_wrap" v-show="diaryShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="diary-box popup_wrap-box" v-show="diaryShow"></div>
        </transition>
        <div class="close-bg" v-show="diaryShow" @click="closePopup('diaryShow')"></div>
      </div>

      <!-- 奖励弹窗——Beter的圣诞袜 -->
      <div class="stocking-wrap popup_wrap" v-show="stockingShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="stocking-box popup_wrap-box" v-show="stockingShow"></div>
        </transition>
        <div class="close-bg" v-show="stockingShow" @click="closePopup('stockingShow')"></div>
      </div>

      <!-- 奖励弹窗——Beter的圣诞帽 -->
      <div class="hat-wrap popup_wrap" v-show="hatShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="hat-box popup_wrap-box" v-show="hatShow"></div>
        </transition>
        <div class="close-bg" v-show="hatShow" @click="closePopup('hatShow')"></div>
      </div>

      <!-- 奖励弹窗——终极强化礼包 -->
      <div class="ultimate-wrap popup_wrap" v-show="ultimateShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="ultimate-box popup_wrap-box" v-show="ultimateShow"></div>
        </transition>
        <div class="close-bg" v-show="ultimateShow" @click="closePopup('ultimateShow')"></div>
      </div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import { headerConfig } from '../headerConfig';
import {
  onGetInitDataAPI, teamInitAPI, teamKickAPI, teamExitAPI, teamJoinAPI, onGetTimeAPI, downloadApps
} from '../api';
import { getRandomString, buriedLogger, wechatBrowser, getTimeStamp, analysisParams } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import QCJumpAuthPlugin from "@qcplay/jump-auth";
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: 'RecallTeamActive',
  components: {
    Header,
    Login,
    swiper,
    swiperSlide,
  },
  data () {
    return {
      activeIndex: 0,
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      // loginTypes: ["sms", "password", "channel"],
      loginTypes: ["sms", "password"],
      autoOpenOS: false,
      preloadingShow: true,
      logger: null,
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      teamShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },

      code: '',
      auth_code: '',
      friend_id: '',
      teamShareLink: '',
      teamShareImg: '',
      activitiesCards: [
        {
          label: 'Tap新版本预约',
          id: 1,
          image: require('../../../../assets/images/active/snail/doubleFestival/3/bg_activity1.png'),
          image2: require('../../../../assets/images/active/snail/doubleFestival/3/act_text_01.png'),
          url: 'https://www.taptap.cn/game-event/9744?preview=1',
          time: '2025-12-12 08:00:00'
        },
        {
          label: 'Tap签到有礼',
          id: 2,
          image: require('../../../../assets/images/active/snail/doubleFestival/3/bg_activity2.png'),
          image2: require('../../../../assets/images/active/snail/doubleFestival/3/act_text_02.png'),
          url: 'https://l.taptap.cn/1il3sPO8?channel=rep-rep_luxbf5c5vq5_h5url5322',
          time: '2025-12-19 00:00:00'
        },
        {
          label: '官方充值',
          id: 3,
          image: require('../../../../assets/images/active/snail/doubleFestival/3/bg_activity3.png'),
          image2: require('../../../../assets/images/active/snail/doubleFestival/3/act_text_03.png'),
          url: '',
          time: '2025-12-19 05:00:00'
        },
        {
          label: 'Tap论坛活动',
          id: 4,
          image: require('../../../../assets/images/active/snail/doubleFestival/3/bg_activity4.png'),
          image2: require('../../../../assets/images/active/snail/doubleFestival/3/act_text_04.png'),
          url: 'https://l.taptap.cn/urbHl2oZ?channel=rep-rep_tgwcddxjkha',
          time: '2025-12-26 00:00:00'
        }
      ],
      gameFeatureCards: [
        { id: 1, image: require('../../../../assets/images/active/snail/doubleFestival/3/game1.png') },
        { id: 2, image: require('../../../../assets/images/active/snail/doubleFestival/3/game2.png') },
        { id: 3, image: require('../../../../assets/images/active/snail/doubleFestival/3/game3.png') },
        { id: 4, image: require('../../../../assets/images/active/snail/doubleFestival/3/game4.png') },
        { id: 5, image: require('../../../../assets/images/active/snail/doubleFestival/3/game5.png') },
        { id: 6, image: require('../../../../assets/images/active/snail/doubleFestival/3/game6.png') },
        { id: 7, image: require('../../../../assets/images/active/snail/doubleFestival/3/game7.png') },
      ],
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1169712.apk',
        ios_url: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1169724&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
      },
      activitiesSwiper: null,
      gameFeatureSwiper: null,
      currentTime: '',
      eggPause: false, // 彩蛋停止晃动

      // 弹窗
      preventShow: false, // 全局遮罩
      wxLoadShow: false, //微信下载弹窗

      eggPopShow: false, // 彩蛋弹窗
      teamDetailShow: false, // 组队消费——详情弹窗
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamKickoutShow: false, // 组队消费——踢出队伍弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗

      beterSecretShow: false, // 圣诞的秘宝弹窗
      diaryShow: false, // 奖励弹窗——开发者日记
      stockingShow: false, // 奖励弹窗——Beter的圣诞袜
      hatShow: false, // 奖励弹窗——Beter的圣诞帽
      ultimateShow: false, // 奖励弹窗——终极强化礼包

      teamActiveInfo: {},
      teamList: Array.from({ length: 6 }, () => ({})),
      packageList: [
        40, 80, 120, 150, 200, 300, 500, 750, 1000, 1500, 2000,
        3000, 4000, 5000, 7500, 10000, 15000, 20000, 25000, 30000
      ].map(score => ({
        score,
        status: 'locked'
      })),
      memberNum: 0,
      curPlayerInfo: {},

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期

      teamOutStatus: false, // 预约期和正式活动期中间的空档五小时

      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      qqNumber: '',
      qqLink: '',
      wechatLink: '',
      pageLink: '',
    }
  },
  created () {
    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
    if (this.isPC) {
      this.$router.push(`pc${getRandomString()}`);
      return
    }

    const targetDate = new Date('2025/12/12 5:00:00');
    // 获取当前时间
    const currentDate = new Date();
    // 计算时间差
    const timeDifference = targetDate - currentDate;
    // 如果时间差大于0，说明在预约期，否则不在预约期
    this.isActiveAppointment = timeDifference ? true : false;
    // console.log("this.isActiveAppointment", this.isActiveAppointment);
    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA = urlParams.get('ua');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('ua');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    const params = analysisParams(window.location.href);
    const { download_id } = params;
    download_id && downloadApps({ download_id, title: 'title' }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    });

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 创建一个数组，长度为6，里面元素是空对象
    this.teamList = Array.from({ length: 6 }, () => ({}));

    // 初始化
    this.onInitDate(true);

    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛_双旦活动');
    this.logger = bl;

    if (queryUA === 'snail') {
      this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=39&ua=snail';
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: "【最强蜗牛】听蜗的当个事儿办！",
      imgUrl: "https://download4.qcplay.com/qcgame-api/NYua9swVA6CmIfnxLMTRGHEuTsog5ZIvNc8yNoSV.png",
      desc: "组队开beter宝库，限定绿贵轻松到手，还有百年VIP卡限时抽取，入队速戳！",
    });
    onGetTimeAPI().then((res) => {
      if (res.code !== 200) {
        return
      }
      this.currentTime = res.data.time
    })
  },
  mounted () {
    this.initSwiper();
    this.initSwiperGameFeature();
    document.addEventListener('click', this.handleGlobalClick, true);
  },
  computed: {
    roleName () {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID).role_name
        : "";
      return roleName;
    },
    phaseLabel() {
      return this.isActiveAppointment ? '预组队期' : '正式活动期';
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin']),
  },
  watch: {
    userInfo: {
      async handler (newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          // console.log('初始登陆/切换角色', newValue);

          const { game_id, role_name, rid, server_name, server_id, access_token, channel } = newValue
          this.getTeamInit();
          const { protocol, host } = window.location;
          this.teamShareLink = `${protocol}//${host}/snail/doubleFestival/enter${getRandomString()}?friend_id=${this.activeInfo.team.team_code}`;
          this.initTeamShareData();

          const login_access_token = localStorage.getItem('doubleFestival_token');
          this.eggPause = localStorage.getItem('doubleFestival_eggPause');

          this.isActiveAppointment = this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS;
          const qcJumpAuth = new QCJumpAuthPlugin({ gameId: game_id || 39 })
          const url = await qcJumpAuth.generateLoginFreeUrl({
            gameId: game_id || 39, flag: 'pay-web', accessToken: access_token ? access_token : login_access_token,
            extraParams: {
              role_id: rid,
              role_name,
              server_id,
              server_name,
              os: channel,
            }
          })
          if (url) {
            this.rechargeUrl = url
          }
        }
      }
    }
  },
  methods: {
    // 事件委托
    handleGlobalClick (e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`最强蜗牛_双旦活动_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    // 隐藏account
    hideAccount () {
      const account = this.userInfo.account;
      if (account) {
        const len = account.length;
        return account.substr(0, 3) + "****" + account.substr(len - 4, 4);
      } else {
        return "";
      }
    },
    // 初始化
    onInitDate (isFirst = false) {
      const codeID = this.code || '';
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code == 401 && (this.friend_id || codeID)){
          this.changeLoginPopup(true);
          return;
        }
        if (response.code !== 200) {
          !isFirst && this.onToast(response.message);
          return;
        }
        this.getTeamListData();
        // console.log("this.activeInfo", this.activeInfo);
        this.teamScore = Number(this.activeInfo.team.team_score) || 0;
        this.scoreList = this.activeInfo.team.score_list || [];
        this.rewardLevel = Number(this.activeInfo.team.level) || 0;
        this.rewardList = this.activeInfo.team.reward_list || [];
        this.teamOutStatus = this.activeInfo.team.team_out_status || false;

        this.qqNumber = this.activeInfo.qq;
        this.qqLink = this.activeInfo.qq_link;
        this.wechatLink = this.activeInfo.url_scheme;
        if (this.activeInfo.team.is_has_out_news) {
          this.onToast('您已被踢出队伍');
        }
        // 设置welfare-list的滚动位置
        const targetElement = document.getElementsByClassName('welfare-list');
        function updatePackageStatus (packages, teamScore) {
          return packages.map(function (pkg, index, arr) {

            if (teamScore >= pkg.score) {
              // 已解锁
              return pkg.status = 'unlock'
            } else {
              // 找到第一个未达标项 → locking
              var prevScore = index > 0 ? arr[index - 1].score : 0;
              if (teamScore >= prevScore && teamScore < pkg.score) {
                // console.log("locking", pkg);
                return pkg.status = 'locking'

              } else {
                return pkg.status = 'locked'
              }
            }
          });
        }
        updatePackageStatus(this.packageList, this.teamScore);
        // console.log("this.packageList", this.packageList);
        // 查找 status 为 locking 的索引
        const idx = this.packageList.findIndex(item => item.status === 'locking');

        // 获取滚动容器
        if (targetElement[0]) {
          // 如果找到了 locking 的项，滚动到对应位置；否则滚动到第一个
          const targetIdx = idx !== -1 ? idx + 1 : 1;

          const targetDom = document.getElementsByClassName(`reward-item-${targetIdx}`)[0];
          if (targetDom) {
            targetElement[0].scrollTop = targetDom.offsetTop - 10;
          }
        }
      });
    },
    clearDate () {
      localStorage.setItem('doubleFestival_eggPause', '');
      this.teamActiveInfo = {};
      this.teamList = Array.from({ length: 6 }, () => ({}));
      this.memberNum = 0;
      this.roleList = [];
      this.recallSharePlayerInfo = {};
      this.teamScore = 0;
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.teamShareImg = '';
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.teamShareCopy = {
        title: '',
        desc: '',
        linkText: ''
      };
      this.eggPause = false;
      this.packageList = [
        40, 80, 120, 150, 200, 300, 500, 750, 1000, 1500, 2000,
        3000, 4000, 5000, 7500, 10000, 15000, 20000, 25000, 30000
      ].map(score => ({
        score,
        status: 'locked'
      }));

    },
    async getTeamInit () {
      const codeID = this.code || '';
      const authCode = this.auth_code || '';
      if (this.friend_id || codeID) {
        const response = await teamInitAPI({ friend_id: this.friend_id, code: codeID, auth_code: authCode });
        if (response.code === 200) {
          const { is_my, number, is_join, level } = response.data.activity;
          if (is_my) {
            this.showPopup('teamJoinFailedMyselfShow');
            this.logger.sum('最强蜗牛_双旦活动_入队失败弹窗（邀请自己）');
          } else if (is_join) {
            this.showPopup('teamJoinFailedHasTeamShow');
            this.logger.sum('最强蜗牛_双旦活动_入队失败弹窗（已有队伍）');
          } else if (number === 6) {
            this.showPopup('teamJoinFailedFullStrengthShow');
            this.logger.sum('最强蜗牛_双旦活动_入队失败弹窗（队伍已满）');
          } else {
            this.teamInvitationNum = number;
            this.teamLevel = level;
            this.showPopup('teamInvitationJoinShow')
          }
        } else {
          this.onToast(response.message);
        }
      }
    },
    downloadApp () {
      const isWechat = wechatBrowser()
      if (isWechat) {
        this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls;
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    goLink (url, loggerName) {
      if (url === '') return
      Indicator.open();
      this.logger.sum(loggerName);
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    initSwiperGameFeature () {
      this.gameFeatureSwiper = new Swiper('.game-feature-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.game-feature-swiper-pagination',
        paginationClickable: true,
        nextButton: '.game-feature-swiper-button-next',
        prevButton: '.game-feature-swiper-button-prev',
      })
    },
    initSwiper () {
      this.activitiesSwiper = new Swiper('.activities-swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        pagination: '.activities-swiper-pagination',
        paginationClickable: true,
        nextButton: '.activities-swiper-button-next',
        prevButton: '.activities-swiper-button-prev',
        onSlideChangeStart: (swiper) => {
          this.activeIndex = swiper.realIndex
          this.scrollToCenter(swiper.realIndex)
        }
      })
      this.activeIndex = this.activitiesSwiper.realIndex
    },
    goToSlide (targetIndex) {
      const swiper = this.activitiesSwiper;
      const currentIndex = swiper.activeIndex; // 当前 DOM 索引
      const slides = Array.from(swiper.slides); // 克隆后的所有 slide

      // 获取所有匹配的 slide 索引
      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      // 找到与当前 slide 最接近的目标 index
      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 300);
        this.activeIndex = targetIndex;
        this.scrollToCenter(targetIndex)
      }
    },
    enterUrl () {
      const { label, url, time } = this.activitiesCards.find((i, index) => index === this.activeIndex) || {}
      if (this.isNotStarted(time)) return
      this.goLink(url, `最强蜗牛_双旦活动_${label}跳转`)
    },
    scrollToCenter (index) {
      const container = this.$refs.tabsContainer;
      const tabItems = this.$refs.tabItems;
      const tab = tabItems[index];

      // 计算滚动的中心位置
      const tabOffsetLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const containerWidth = container.offsetWidth;

      const scrollPosition = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
      container.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    },
    isNotStarted (time) {
      const current = this.parseTimeStr(this.currentTime);
      const target = this.parseTimeStr(time);
      return target.getTime() > current.getTime();
    },

    parseTimeStr (str) {
      if (!str) return new Date("");

      // 清理空格
      str = str.trim();

      // 拆分日期和时间
      const [dateStr, timeStr = "00:00:00"] = str.split(" ");

      const [year, month, day] = dateStr.split(/[-\/]/).map(Number);
      const [hour, minute, second] = timeStr.split(":").map(Number);

      // 注意：month 需要 -1
      return new Date(year, month - 1, day, hour, minute, second);
    },
    openFindTeamShow () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum('最强蜗牛_双旦活动_寻找搭子按钮');
      this.showPopup('findTeamShow');
    },
    toGroupOfQQ () {
      if (wechatBrowser()) {
        this.closePopup('findTeamShow');

        this.showPopup('qqGroupShow');
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat () {
      window.location.href = this.wechatLink;
    },
    initTeamShareData () {
      try {
        this.teamShareCopy = {
          title: '【最强蜗牛】听蜗的当个事儿办！',
          desc: '组队开beter宝库，限定绿贵轻松到手，还有百年VIP卡限时抽取，入队速戳！',
          linkText: `
【最强蜗牛】
听蜗的当个事儿办！
加入寻宝小队，开启Beter宝库
领取限定绿贵就像呼吸一样简单
还有百年VIP卡限时抽取
入队速戳：
${this.teamShareLink}
          `.trim()
        };

        this.qrcode('team-qrcode', `${this.teamShareLink}`);
        this.$nextTick(() => {
          this.generateTeamShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        // console.log('组队分享初始化失败', err);
      }
    },
    // 生成二维码
    qrcode (id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#eee4d4',
        colorLight: '#c5a790',
        correctLevel: 1 // ✅ 设置容错等级为 L
      });
    },
    onCopy (id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    // 分享图片设置
    generateTeamShareImage (successCallback, failedCallback) {
      generateCanvasImage(this.$refs.teamImageDom)
        .then((canvas) => {
          this.teamShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          successCallback && successCallback();
          // console.log('组队分享图生成成功');
        })
        .catch((err) => {
          failedCallback && failedCallback();
          // console.log('组队分享图生成失败', err.message);
        });
    },
    showEgg () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.eggPause = true;
      this.showPopup('eggPopShow');
      localStorage.setItem('doubleFestival_eggPause', true);
    },
    onTeamShare () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?friend_id=${this.activeInfo.team.team_code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.teamShareLink,
          title: this.teamShareCopy.title,
          imgUrl: "https://download4.qcplay.com/qcgame-api/NYua9swVA6CmIfnxLMTRGHEuTsog5ZIvNc8yNoSV.png",
          desc: this.teamShareCopy.desc,
        });
        this.teamWechatShareShow = true;
        this.logger.sum('最强蜗牛_双旦活动_引导遮罩')
      } else {
        this.onPreventShow();
        this.generateTeamShareImage(() => {
          this.onPreventClose();
          this.teamNotWechatShareShow = true;
        }, () => {
          this.onPreventClose();
        })
      }
    },
    closeWechatShare (popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    getTeamListData () {
      let teamList = this.activeInfo.team.team_list || [];
      teamList.forEach((item) => {
        item.is_myself = this.userInfo.user_id === item.id;

        // item.is_kick_out = this.activeInfo.team.activity_status;
        item.is_kick_out = this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS &&
          this.activeInfo.team.is_first && !item.is_myself && !this.activeInfo.team.team_out_status;

        if (item.is_first) {
          item.is_kick_out = false;
        }
      });
      // 如果teamList长度小于6，用空对象填充
      if (teamList.length < 6) {
        const fillCount = 6 - teamList.length;
        const fillArray = Array.from({ length: fillCount }, () => ({}));
        teamList = teamList.concat(fillArray);
      }
      this.teamList = teamList;
      this.memberNum = this.activeInfo.team.team_list.length;
    },
    // 查看我的组队
    toMyTeamByTeam () {
      this.closePopup('teamJoinFailedHasTeamShow');
      // TODO: 锁定到页面召回板块
      this.scrollIntoTeamBox();
    },
    scrollIntoTeamBox () {
      const targetElement = document.getElementById('team-consumption-box');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    readPlayerInfo (id) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      // console.log("curPlayerInfo", curPlayerInfo);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      this.showPopup('teamPlayerInfoShow');
    },
    kickoutPlayer (id) {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      const curPlayerInfo = this.teamList.find(item => item.id === id);
      // console.log("curPlayerInfo", curPlayerInfo);
      if (!curPlayerInfo) return;
      this.curPlayerInfo = curPlayerInfo;
      if (this.curPlayerInfo.is_kick_out) {
        clearInterval(this.kickOutTimer);
        this.kickOutSeconds = 10;
        this.showGrayKickOutBtn = true;
        this.kickOutTimer = setInterval(() => {
          this.kickOutSeconds--;
          if (this.kickOutSeconds <= 0) {
            clearInterval(this.kickOutTimer);
            this.showGrayKickOutBtn = false;
          }
        }, 1000);
      }
      this.showPopup('teamKickoutShow');
    },
    // 踢出队伍
    async onKickOut () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamKickAPI({ id: this.curPlayerInfo.id });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('已踢出队伍');
        this.closePopup('teamKickoutShow');
        this.onInitDate();
        this.logger.sum('最强蜗牛_双旦活动_弹窗-踢出队伍');
      }
      this.onPreventClose();
    },
    // 查看更多积分
    onMorePoints () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }

      if(this.isActiveAppointment){
        this.onToast('活动还未开始，蜗爷12月19日再来吧~');
        return;
      }

      if (this.teamScore) {
        this.showPopup('teamPointsRecordShow');
      } else {
        this.showPopup('teamNotPointsRecordShow');
      }
    },
    // 跳转到充值网站
    toRecharge () {
      if(this.isActiveAppointment){
        this.onToast('活动还未开始，蜗爷12月19日再来吧~');
        return;
      }

      window.location.href = this.rechargeUrl;
    },
    async onExitTeam () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await teamExitAPI();
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.closePopup('teamExitShow');
        this.onInitDate();
        this.onToast(response.message);
      }
      this.onPreventClose();
    },
    async agreeJoinTeam () {
      const codeID = this.code || '';
      const authCode = this.auth_code || '';
      this.onPreventShow();
      const response = await teamJoinAPI({ friend_id: this.friend_id, code: codeID, auth_code: authCode });
      if (response.code !== 200) {
        this.onToast(response.message);
      } else {
        this.onToast('入队成功');
      }
      this.onPreventClose();
      this.closePopup('teamInvitationJoinShow');
      this.closePopup('teamInvitationConfirmShow');
      this.onInitDate();
    },
    openInvitetation () {
      this.closePopup('teamInvitationJoinShow');
      this.showPopup('teamInvitationConfirmShow');
    },
    loginSuccess () {
      this.onInitDate();
    },
    loginCallback (response) {
      localStorage.setItem('doubleFestival_token', response.data.access_token)
    },
    clickReward (id) {
      const popupList = [
        'beterSecretShow', // 40积分
        'beterSecretShow', // 80积分
        'diaryShow',       // 120积分（开发者日记）
        'beterSecretShow', // 150积分
        'beterSecretShow', // 200积分
        'stockingShow',    // 300积分（Beter的圣诞袜）
        'beterSecretShow', // 500积分
        'beterSecretShow', // 750积分
        'hatShow',         // 1000积分（Beter的圣诞帽）
        'beterSecretShow', // 1500积分
        'beterSecretShow', // 2000积分
        'ultimateShow',    // 3000积分（终极强化礼包）
        'beterSecretShow', // 4000积分
        'beterSecretShow', // 5000积分
        'beterSecretShow', // 7500积分
        'beterSecretShow', // 10000积分
        'beterSecretShow', // 15000积分
        'beterSecretShow', // 20000积分
        'beterSecretShow', // 25000积分
        'beterSecretShow'  // 30000积分
      ];
      const specialLogs = {
        diaryShow: '开发者日记弹窗',
        stockingShow: '圣诞袜弹窗',
        hatShow: '圣诞帽弹窗',
        ultimateShow: '终极礼包弹窗'
      };

      const popupName = popupList[id];
      if (!popupName) return;

      // 只有四个特殊弹窗需要埋点
      if (specialLogs[popupName]) {
        this.logger.sum(`最强蜗牛_双旦活动_Beter的${specialLogs[popupName]}`);
      } else {
        this.logger.sum('最强蜗牛_双旦活动_Beter的秘宝弹窗');
      }

      // 打开弹窗
      this.showPopup(popupName);
    },
    // 格式化日期
    formatDate (dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : '0' + minutes}:${seconds >= 10 ? seconds : '0' + seconds}`;
    },
    openLoginByScore () {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    openLoginByPlayer () {
      // console.log(this.userInfo.user_id);
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    // TAG: 其他简易封装的方法
    onToast (config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow () {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose () {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup (name) {
      this[name] = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    inputFocus () {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut () {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/doubleFestival/index/index.vue